import {
  anEntityCriticalityConfigPage,
  anInsightStatus,
  aTeamPage,
  aUserPage,
  aVisitedEntityPage,
  aVisitedSearchQueryPage,
  mockSearchHistoryOperationQuery,
} from '__generated__';
import { delay, HttpResponse } from 'msw';

export const handlers = [
  mockSearchHistoryOperationQuery(
    async ({ query: _query, variables: _variables }) => {
      await delay(1500);
      return HttpResponse.json({
        data: {
          __typename: 'Query',
          recentlyVisitedDetailPages: [aVisitedEntityPage()],
          recentlyVisitedSearchQueryPages: [aVisitedSearchQueryPage()],
          insightStatuses: [anInsightStatus()],
          teams: aTeamPage(),
          users: aUserPage(),
          entityCriticalityConfigs: anEntityCriticalityConfigPage(),
        },
      });
    }
  ),
];
